import { useRef, useState, useEffect } from "react";
import "./accordion.scss";
import { whiteRightArrow } from "../../source";

export const CustomAccordion = ({
  items,
  firstActive = false,
  onAccordionChange,
}) => {
  const [openIndex, setOpenIndex] = useState(firstActive === true ? 0 : "");
  const activeAccordionRef = useRef(null);
  const descRefs = useRef([]);

  const handleItemClick = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
    if (onAccordionChange) {
      onAccordionChange(index); // Notify the parent
    }
  };

  const scrollToActiveAccordion = () => {
    if (activeAccordionRef.current) {
      activeAccordionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  useEffect(() => {
    scrollToActiveAccordion();
  }, [openIndex]);

  useEffect(() => {
    descRefs.current.forEach((ref, index) => {
      if (ref) {
        if (index === openIndex) {
          const height = ref.scrollHeight;
          ref.style.height = `${height}px`;
        } else {
          ref.style.height = "0px";
        }
        // ref.style.overflow = "hidden";
        // ref.style.transition = "height 0.3s ease";
      }
    });
  }, [openIndex]);

  return (
    <>
      <div className="custom-accordion-container">
        {items.map((item, index) => (
          <div
            className={`custom-accordion-wrapper ${
              openIndex === index ? "active" : ""
            }`}
            key={index}
            // ref={openIndex === index ? activeAccordionRef : null}
          >
            <div
              className="accordion-title"
              onClick={() => {
                handleItemClick(index);
                // handleMouseEnter(index);
              }}
            >
              <span>{item.title}</span>
              {openIndex === index && (
                <div className="arrow_wrapper">
                  <img
                    className="arrow"
                    src={whiteRightArrow}
                    width={50}
                    height={50}
                    alt="arrow"
                  />
                </div>
              )}
            </div>
            <div
              className={`custom-accordion-item ${
                openIndex === index ? "active" : ""
              }`}
              ref={(el) => (descRefs.current[index] = el)}
            >
              <div
                className="accordion-content"
                dangerouslySetInnerHTML={{ __html: item.content }}
              />
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
